var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import FilledInput from '@mui/material/FilledInput';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import InputAdornment from '@mui/material/InputAdornment';
import Typography from '@mui/material/Typography';
export const Textarea = (_a) => {
    var { dataQa, label, value, helperText, showCount, maxChar, error, onChange } = _a, rest = __rest(_a, ["dataQa", "label", "value", "helperText", "showCount", "maxChar", "error", "onChange"]);
    const [valueCount, setValueCount] = useState(0);
    useEffect(() => {
        setValueCount((value === null || value === void 0 ? void 0 : value.length) || 0);
    }, [value]);
    const handleChange = (event) => {
        let newValue = event.target.value;
        if (maxChar && newValue.length > maxChar) {
            newValue = newValue.slice(0, maxChar);
        }
        if (onChange) {
            onChange({ target: { value: newValue } });
        }
    };
    return (React.createElement(FormControl, { variant: "filled", "data-qa": dataQa ? dataQa : 'textarea-core' },
        label && React.createElement(InputLabel, null, label),
        React.createElement(FilledInput, Object.assign({}, rest, { value: value, error: error, minRows: 4, endAdornment: showCount ? (React.createElement(InputAdornment, { position: "end" },
                React.createElement(Typography, { variant: "caption" }, maxChar ? `${valueCount}/${maxChar}` : valueCount))) : undefined, onChange: handleChange })),
        React.createElement(FormHelperText, { error: error }, helperText)));
};
